import React from 'react'

export const IconButton = ({
  disabled,
  onClick,
  icon = 'pencil',
  variant = 'primary',
  size = 'small',
  classNames = '',
}) => (
  <button
    type="button"
    aria-label="Button"
    disabled={disabled}
    onClick={onClick}
    className={`wb-button wb-button--${variant} wb-button--${size} wb-button--icon-only ${classNames}`}
  >
    <wb-icon
      class="wb-button__icon"
      aria-hidden="true"
      name={`bds/${icon}/16`}
    ></wb-icon>
    {icon}
  </button>
)
